<template>
  <article class="auction-detail">
    <group>
      <cell>
        <p slot="after-title">{{user.name}}</p>
        <p slot="after-title" class="fc-blue" @click.native="callPhone(user.mobile_number)">{{user.mobile_number}}</p>
        <a
          class="auction-detail__label"
          :class="{ 'auction-detail__red': status !== 1 }">
          {{ status | statusDict }}
        </a>
      </cell>
      <cell class="usedcar-detail">
        <p slot="after-title"><span>加入时间</span>{{user.created_at || '- -'}}</p>
        <p slot="after-title"><span>车商类型</span>{{organization.organization_type}}</p>
        <p slot="after-title"><span>车商名称</span>{{organization.name || '- -'}}</p>
        <p slot="after-title"><span>负责人</span>{{organization.legal_person_name}}</p>
        <p slot="after-title"><span></span></p>
        <p slot="after-title"><span>所在地区</span>{{organization.province || '- -' }}，{{organization.city || '- -'}}</p>
        <p slot="after-title"><span>具体地址</span>{{organization.address || '- -'}}</p>
      </cell>
      <cell class="usedcar-detail">
        <!--<p slot="after-title"><span>邀请方</span>{{organization.store.city}}，{{organization.store.name}}</p>-->
        <p slot="after-title">
          <span>邀请方</span>
          {{ invitationStore.name }}
          <span v-if="invitationStore.city">{{ `，${invitationStore.city}` }}</span>
        </p>
      </cell>
    </group>
    <h2 class="tip-sub">提示：如该用户存在竞拍违规等不良行为，请及时举报。<br>举报联系：<a href="tel:4006280808" style="color: #5890ff;">400 628 0808</a></h2>
  </article>
</template>
<script>
// 竞拍人详情
import { Cell, Group } from '@lx-frontend/cvux'
export default {
  components: {
    Cell,
    Group
  },
  data() {
    return {
      // carSource: ['未知', '二手车经销商', '4S店', '经纪公司', '个人中介'],
      user: {},
      organization: {
        store: {}
      },
      invitationStore: {},
      status: ''
    }
  },
  filters: {
    statusDict(val) {
      const dict = {
        '1': '正常',
        '2': '冻结',
        '3': '已停用'
      }
      return dict[val] || '--'
    }
  },
  created() {
    let id = this.$route.params.id
    if (id) {
      this.$rest.inquiry.getDealerUsersDetail(null, id).then(({ code, data, message }) => {
        if (code === 0) {
          if (data) {
            this.organization = data.organization
            this.user = data.user
            this.invitationStore = data.invitation_store
            this.status = data.status
          }
        } else {
          this.showToast(message)
        }
      })
    }
  },
  methods: {
    callPhone(phone) {
      window.location.href = 'tel:' + phone
    }
  }
}

</script>
<style rel="stylesheet/less" lang="less">
  @w2: 75rem;
  .auction-detail {
    .fc-blue {
      line-height: 1.2;
      font-size: 26/@w2;
      color: #5890ff;
    }
    &__label {
      font-size: 12px;
    }
    &__red {
      color: red;
    }
    .usedcar-detail p {
      font-size: 26/@w2;
      line-height: 2.1;
      span {
        display: inline-block;
        width: 22%;
        color: #737373c2;
      }
      .special-title {
        margin-right: -7/@w2;
        vertical-align: top;
      }
      .special {
        display: inline-block;
        width: 75%;
        color: #000;
      }
    }
    .tip-sub {
      position: absolute;
      bottom: 0;
      width: 100%;
      line-height: 40/@w2;
      font-size: 26/@w2;
      color: #676767;
      text-align: center;
    }
  }

</style>
